<template>
  <!--  医院概况-->
  <div id="survey">
    <div>
      <BannerSwiper msg="医院介绍"></BannerSwiper>
      <!-- 轮播位置 -->
    </div>

    <div style="position: relative; top: 10px; left: 0px" id="administrative">
      <breadcrumb msg="医院概况" id="breadcrumb"></breadcrumb>
    </div>
    <!-- 导航条 -->

    <!-- <Pswiper :doctorList="doctorForms" src="领导团队"></Pswiper> -->
    <!-- <div id="figure1">
      <div id="title">组织架构</div>
      <div style="width:1200px;margin:0 auto">
        <img style="width:100%;height: 500px" :src="projectForm.organization" alt />
      </div>
    </div>-->
    <div id="figure2">
      <div id="allCard">
        <div id="doctorList">
          <div id="title">领导团队</div>
          <div id="doctorTypeList">
            <div v-for="item in doctorForms" :key="item.id" id="card" @click="open1(item.id)">
              <div id="swiperImg">
                <img style="width: 100%; height: 100%" :src="item.src" />
              </div>
              <div id="swiperName">
                <div>{{ item.name }}</div>
                <div v-html="item.position"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="title">医院荣誉</div>
      <div
        class="swiper-container swiper3"
        style="width: 1250px; height: 250px"
      >
        <div class="swiper-wrapper" style="height: 100%; width: 250px">
          <div class="swiper-slide" v-for="item in courtyard" :key="item.id">
            <img
              style="width: 80%; height: 80%; margin: 10px"
              :src="item.fileUrl"
              alt
            />
          </div>
        </div>
        <div class="swiper-button-next" style="right: 0">
          <img
            style="width: 100%; height: 100%"
            src="../assets/img/right1.png"
            alt=""
          />
        </div>
        <!-- 白色 -->
        <div class="swiper-button-prev swiper4" style="left: 0">
          <img
            style="width: 100%; height: 100%"
            src="../assets/img/left1.png"
            alt=""
          />
        </div>
        <!-- 黑色 -->
        <div class="swiper-pagination swiper"></div>
      </div>
    </div>
  </div>
</template>
<script>
import Swiper from "swiper";
// import Pswiper from "../components/swiper";
import BannerSwiper from "../components/bannerSwiper";
import "../../node_modules/swiper/css/swiper.css";
import breadcrumb from "../components/breadcrumb";

export default {
  components: { breadcrumb, BannerSwiper },
  data() {
    return {
      sectionList: JSON.parse(sessionStorage.getItem("sectionList")),
      projectForm: JSON.parse(sessionStorage.getItem("projectForm")),
      courtyard: JSON.parse(sessionStorage.getItem("courtyard")),
      doctorForms: JSON.parse(sessionStorage.getItem("doctorForms")),
      img: [],
    };
  },
  mounted() {
    // var mySwiper = new Swiper(".swiper", {
    //   autoplay: true,
    //   loop: true
    // });
    var mySwiper2 = new Swiper(".swiper3", {
      slidesPerView: 3,
      slidesPerGroup: 1,
      // loop: true,
      // initialSlide: 2,
      spaceBetween: 10,
      centeredSlides: true,
      autoplay: false,
      centeredSlidesBounds: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
        dynamicBullets: true,
      },
    });
  },
  created() {
    // console.log(this.$route.path)
    for (let i = 0; i < this.sectionList.length; i++) {
      if ("/" + this.sectionList[i].url === this.$route.path) {
        this.img = this.sectionList[i].fileList;
      }
    }
    // console.log(this.img)
  },
  methods: {
    open1(id) {
      this.$router.push({ name: "leadership", query: { id: id } });
      // if(this.$route.path == '/Survey'){
      //   this.$router.push({name:'leadership',query:{id:id}})
      // }else{
      //   this.$router.push({name:'doctorList',query:{id:id}})
      // }
    },
    open(item) {
      this.$router.push({ path: "/body", query: item });
    },
  },
};
</script>
<style lang="less" scoped>
#allCard {
  width: 100%;
  background-image: url(../assets/img/jpg8.jpg);
}
#swiperName {
  font-size: 1.9vh;
  font-weight: 600;
  // color:rgb(69, 109, 171)
}
#doctorTypeList {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-content: flex-start;
  width: 1200px;
  margin: 0 auto;
  #card {
    background-image: url(../assets/img/jpg19_03.jpg);
    background-size: 100% 100%;
    margin: 10px 10px;
    width: 220px;
  }
}
#swiperImg {
  // margin: 20px 0;
  padding: 20px 25px 10px;
  // margin-bottom: 10px;
  /*background-image: url(../assets/img/s5dbfc85a93c43.jpg);*/
  background-size: 100% 100%;
}
#doctorList {
  width: 100%;
  min-width: 1300px;
  #title {
    font-size: 30px;
    padding: 35px;
    padding-top: 50px;
    // font-weight: 600;
    font-family: dasongbiao;
    color: rgb(69, 109, 171);
  }
}
.swiper-button-prev:after,
.swiper-container-rtl .swiper-button-next:after {
  display: none;
}

.swiper-button-prev:after,
.swiper-button-next:after {
  display: none;
}

#figure {
  width: 100%;
  height: 500px;
  background-image: url(../assets/img/jpg8.jpg);
  text-align: center;
}

.swiper-slide-active {
  color: #fff;
}

#figure1 {
  width: 100%;
  height: 700px;
  background-color: #456dab;
  text-align: center;
}

#figure2 {
  width: 100%;
  background-image: url(../assets/img/1121.png);
  text-align: center;

  .swiper3 img {
    cursor: pointer;
    transition: all 0.6s;
  }

  .swiper3 img:hover {
    transform: scale(1.1);
    overflow: hidden;
  }
}

#title {
  font-size: 30px;
  padding: 35px;
  font-family: dasongbiao;
  color: rgb(69, 109, 171);
}

#shadow {
  width: 100%;
  height: 100%;
  position: absolute;
  background: rgba(0, 0, 0, 0.4);
}

#swiperFont {
  position: absolute;
  right: 300px;
  top: 50px;

  #name {
    font-size: 32px;
    width: 40px;
    padding: 20px;
    text-align: center;
    position: absolute;
    top: 40px;
  }

  #borderTop {
    width: 80px;
    height: 100px;
    position: absolute;
    background-image: url(../assets/img/png3_03.png);
    background-size: 100% 100%;
  }

  #borderBottom {
    width: 80px;
    height: 100px;
    position: absolute;
    top: 180px;
    background-image: url(../assets/img/png4_03.png);
    background-size: 100% 100%;
  }
}

#swiperText {
  position: absolute;
  right: 350px;
  height: 80%;
  top: 40px;
  writing-mode: tb-rl;
}

#swiperDetail :hover {
  cursor: pointer;
}

#swiperDetail {
  position: absolute;
  right: 460px;
  top: 45px;
  font-size: 22px;
  padding: 10px;

  #top {
    width: 100%;
    height: 20px;
    margin-bottom: 10px;
    background-image: url(../assets/img/png1_03.png);
    background-size: 100% 100%;
  }

  #bottom {
    width: 100%;
    height: 20px;
    margin-top: 10px;
    background-image: url(../assets/img/png2_03.png);
    background-size: 100% 100%;
  }
}
</style>
<style lang="less">
#survey {
  /deep/ #figure[data-v-15c305d8] {
    // background-image: none;
    background-image: url(../assets/img/1121.png);
  }
}
</style>
